/**
 * Recursively collects all synonym names from a tree of ingredient nodes.
 *
 * @param {Object} root - The root node or object containing ingredient nodes.
 * @returns {Array} An array containing all synonym names found in the tree.
 */
const getAllNodesSynonyms = (root) => {
  if (!root) return []

  const synonymsList = []

  Object.values(root).forEach((node) => {
    if (Array.isArray(node?.synonyms)) {
      node.synonyms.forEach((s) => {
        if (s?.names) {
          synonymsList.push(s.names)
        }
      })
    }

    if (node?.children) {
      synonymsList.push(...getAllNodesSynonyms(node.children))
    }
  })

  return synonymsList
}

export default getAllNodesSynonyms
